

if (!customElements.get('orrling-story')) {
 class OrrlingStory extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort=new AbortController();this.index=0;this.userPaused=false;this.visible=false;this.hovered=false;this.focused=false;
   this.slides=[...this.querySelectorAll('.orrling-story__slide')];this.dots=[...this.querySelectorAll('.orrling-story__dot')];this.pause=this.querySelector('.orrling-story__pause');
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.userPaused=this.motion.matches;
   const on=(el,event,fn)=>el.addEventListener(event,fn,{signal:this.abort.signal});
   on(this.pause,'click',()=>{this.userPaused=!this.userPaused;this.sync();});
   this.dots.forEach((dot,i)=>on(dot,'click',()=>{this.show(i);this.sync();}));
   on(document,'visibilitychange',()=>this.sync());
   on(this.motion,'change',()=>{if(this.motion.matches)this.userPaused=true;this.sync();});
   on(this,'keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));this.sync();}});
   on(this,'pointerdown',e=>{this.start={x:e.clientX,y:e.clientY};this.swiped=false;});
   on(this,'pointerup',e=>{if(!this.start)return;const dx=e.clientX-this.start.x,dy=e.clientY-this.start.y;this.start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3){this.swiped=true;this.show(this.index+(dx<0?1:-1));this.sync();}});
   on(this,'pointercancel',()=>{this.start=null;});
   this.addEventListener('click',e=>{if(this.swiped){e.preventDefault();this.swiped=false;}},{capture:true,signal:this.abort.signal});
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.2});this.observer.observe(this);
   this.first=true;this.show(0);this.sync();
  }
  show(n){this.index=(n+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===this.index);slide.setAttribute('aria-hidden',String(i!==this.index));});this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));}
  sync(){clearTimeout(this.timer);if(!this.abort)return;this.pause.textContent=this.userPaused?'▶':'Ⅱ';this.pause.setAttribute('aria-label',this.userPaused?this.dataset.play:this.dataset.pause);this.pause.setAttribute('aria-pressed',String(this.userPaused));const stopped=this.userPaused||!this.visible||document.hidden;this.dataset.paused=String(stopped);if(!stopped){const delay=4200+(this.first?Number(this.dataset.offset||0):0);this.timer=setTimeout(()=>{this.first=false;this.show(this.index+1);this.sync();},delay);}}
  disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect();this.abort?.abort();this.abort=null;}
 }
 customElements.define('orrling-story',OrrlingStory);
}


(() => {
  const desktop = matchMedia('(min-width: 990px) and (hover: hover)');
  const instances = new WeakSet();
  const direct = (el, selector) => el.querySelector(':scope > ' + selector);
  const make = (tag, cls, text) => {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text) el.textContent = text;
    return el;
  };
  let sequence = 0;
  const managed = [];
  function enhance(trigger) {
    if (instances.has(trigger)) return;
    const root = trigger.parentElement;
    const source = direct(root, '.gm-submenu');
    if (!source) return;
    let categories = Array.from(source.children).map(item => {
      const link = direct(item, 'a');
      return { link, label: link?.textContent.trim(), links: Array.from(item.querySelectorAll('ul a[href]')) };
    }).filter(item => item.link);
    if (!categories.length || !categories[0].links.length) return;
    const additions = document.getElementById('orrling-bridal-additions');
    if (additions) {
      const original = categories;
      const engagement = original.find(c => c.links.some(a => a.getAttribute('href')?.includes('/collections/embrace-rings')));
      const wedding = original.find(c => c.links.some(a => a.getAttribute('href')?.includes('/collections/wedding-rings-for-her')));
      const academyCategory = original.find(c => c.link.getAttribute('href')?.includes('/pages/guide-to-diamonds'));
      if (engagement && wedding && academyCategory) {
        engagement.label = additions.dataset.engagement;
        wedding.label = additions.dataset.wedding;
        academyCategory.label = additions.dataset.academy;
        const browseGroups = original.filter(c => ![engagement,wedding,academyCategory].includes(c));
        browseGroups.forEach(c => {
          if (c.label.toUpperCase() === 'SETTINGS') c.label = 'Settings';
          if (c.label.toUpperCase() === 'DIAMOND BY CUT') c.label = 'Diamond by Cut';
        });
        engagement.groups = [];
        const extra = group => Array.from(additions.content.querySelectorAll('[data-group="' + group + '"]'));
        wedding.links = [...wedding.links, ...extra('wedding')];
        const category = group => ({label:additions.dataset[group], link:extra(group)[0], links:extra(group)});
        categories = [engagement,...browseGroups,wedding,category('celebration'),academyCategory,category('atelier')].filter(c => c.link);
      }
    }
    instances.add(trigger);
    const id = 'orr-bridal-' + (++sequence);
    const panel = make('div', 'omb-panel');
    panel.id = id;
    panel.hidden = true;
    panel.setAttribute('aria-label', trigger.textContent.trim());
    const tabs = make('div', 'omb-tabs');
    tabs.setAttribute('role', 'tablist');
    tabs.setAttribute('aria-label', trigger.textContent.trim());
    const body = make('div', 'omb-body');
    const footer = make('div', 'omb-footer');
    if (additions) additions.content.querySelectorAll('[data-footer]').forEach(a => footer.append(a.cloneNode(true)));
    const academy = categories.find(item => item.link.getAttribute('href')?.includes('/pages/guide-to-diamonds'));
    // Diamond Academy remains accessible through its image-card tab.
    panel.append(tabs, body, footer);
    document.body.append(panel);
    managed.push({trigger, panel});
    root.classList.add('omb-source');
    const originalControls = trigger.getAttribute('aria-controls');
    let opened = false, active = 0, closeTimer, academyRequest;
    const views = [], buttons = [];
    const header = trigger.closest('header-component');
    function card(link) {
      const a = make('a', 'omb-card');
      for (const attr of ['href', 'target', 'rel', 'translate']) {
        if (link.hasAttribute(attr)) a.setAttribute(attr, link.getAttribute(attr));
      }
      if (link.classList.contains('notranslate')) a.classList.add('notranslate');
      const image = link.querySelector('img');
      if (image) {
        const img = make('img');
        const hydrate = () => {
          const srcset = image.getAttribute('data-srcset') || image.getAttribute('srcset');
          const src = image.getAttribute('data-src') || image.getAttribute('src') || image.currentSrc;
          if (srcset && !srcset.startsWith('data:')) {
            img.srcset = srcset;
            img.src = srcset.split(',')[0].trim().split(' ')[0];
            return true;
          }
          if (src && !src.startsWith('data:')) { img.src = src.replace(/\{width\}|%7Bwidth%7D/gi, '610'); return true; }
          return false;
        };
        if (!hydrate()) {
          const loader = new MutationObserver(() => { if (hydrate()) loader.disconnect(); });
          loader.observe(image, {attributes:true, attributeFilter:['data-srcset','srcset','data-src','src']});
        }
        img.sizes = '(min-width: 1600px) 260px, 16vw';
        img.width = 400;
        img.height = 400;
        img.alt = '';
        img.decoding = 'async';
        a.append(img);
      }
      a.append(make('span', '', link.textContent.trim()));
      return a;
    }
    function groupedLinks(category) {
      const groups = make('div', 'omb-groups');
      (category.groups || []).forEach(group => {
        const row = make('div', 'omb-group');
        row.append(make('strong', '', group.label));
        group.links.forEach(link => { const a = link.cloneNode(true); a.querySelectorAll('img').forEach(img => img.remove()); row.append(a); });
        if (group.link.getAttribute('href')) row.append(group.link.cloneNode(true));
        groups.append(row);
      });
      return groups;
    }
    // Native details keep all original destinations available on touch screens.
    if (additions) {
      const mobile = make('li', 'omb-mobile');
      categories.forEach(category => {
        const details = make('details');
        details.append(make('summary', '', category.label));
        const links = category.links.length ? category.links : [category.link];
        links.forEach(link => { const a = link.cloneNode(true); a.querySelectorAll('img').forEach(img => img.remove()); details.append(a); });
        details.append(groupedLinks(category));
        mobile.append(details);
      });
      additions.content.querySelectorAll('[data-footer]').forEach(a => mobile.append(a.cloneNode(true)));
      mobile.addEventListener('click', event => {
        if (event.target.closest('a[href]')) trigger.closest('header-drawer')?.close();
      });
      source.append(mobile);
      source.classList.add('omb-mobile-source');
    }
    categories.forEach((category, index) => {
      const button = make('button', 'omb-tab', category.label);
      button.type = 'button';
      button.id = id + '-tab-' + index;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', id + '-view-' + index);
      const view = make('div', 'omb-view');
      view.id = id + '-view-' + index;
      view.setAttribute('role', 'tabpanel');
      view.setAttribute('aria-labelledby', button.id);
      const grid = make('div', 'omb-grid');
      category.links.forEach(link => grid.append(card(link)));
      if (!category.links.length && category.link.hasAttribute('href')) grid.append(card(category.link));
      view.append(grid, groupedLinks(category));
      tabs.append(button);
      body.append(view);
      buttons.push(button);
      views.push(view);
      let hoverTimer;
      button.addEventListener('pointerenter', () => { hoverTimer = setTimeout(() => select(index),300); });
      button.addEventListener('pointerleave', () => clearTimeout(hoverTimer));
      button.addEventListener('click', () => clearTimeout(hoverTimer));
      button.addEventListener('keydown', () => clearTimeout(hoverTimer));
      button.addEventListener('click', () => select(index));
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next !== undefined) { event.preventDefault(); select(next); buttons[next].focus(); }
      });
    });
    function select(index) {
      active = index;
      buttons.forEach((button, i) => {
        button.setAttribute('aria-selected', String(i === index));
        button.tabIndex = i === index ? 0 : -1;
        views[i].hidden = i !== index;
      });
      if (categories[index] === academy) loadAcademy();
    }
    async function loadAcademy() {
      if (!academy || academyRequest) return;
      const index = categories.indexOf(academy);
      academyRequest = true;
      try {
        const response = await fetch(academy.link.href, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Academy unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const chapterLinks = Array.from(doc.querySelectorAll('.oda-nav a[href^="#"]'));
        if (!chapterLinks.length) throw new Error('Academy chapters unavailable');
        const grid = make('div', 'omb-grid omb-academy');
        chapterLinks.forEach(link => {
          const section = doc.getElementById(link.getAttribute('href').slice(1));
          if (!section) return;
          const a = make('a', 'omb-card');
          a.href = academy.link.href.split('#')[0] + link.getAttribute('href');
          const original = section.querySelector('img[srcset]') || section.querySelector('img');
          if (original) {
            const img = make('img');
            img.src = original.getAttribute('src');
            if (original.getAttribute('srcset')) img.srcset = original.getAttribute('srcset');
            img.sizes = '14vw';
            img.alt = '';
            img.width = 400;
            img.height = 400;
            img.decoding = 'async';
            a.append(img);
          }
          a.append(make('span', '', link.textContent.trim()));
          grid.append(a);
        });
        if (grid.children.length === chapterLinks.length) views[index].replaceChildren(grid);
        const appointment = doc.querySelector('main a[href$="/pages/book-an-appointment"]');
        if (appointment && !footer.querySelector('a[href$="/pages/book-an-appointment"]')) {
          const a = make('a', '', appointment.textContent.replace('↗','').trim());
          a.href = appointment.href;
          a.dataset.appointment = '';
          footer.prepend(a);
        }
      } catch (error) { academyRequest = false; }
    }
    function position() {
      const rect = header?.getBoundingClientRect() || trigger.getBoundingClientRect();
      panel.style.setProperty('--omb-top', Math.max(0, rect.bottom) + 'px');
    }
    function open() {
      clearTimeout(openTimer);
      if (!desktop.matches || !trigger.getClientRects().length) return;
      document.dispatchEvent(new CustomEvent('orrling:menu-open', {detail:panel}));
      clearTimeout(closeTimer);
      if (!opened) {
        categories.forEach((category, index) => {
          if (category === academy) return;
          const grid = make('div', 'omb-grid');
          category.links.forEach(link => grid.append(card(link)));
          views[index].replaceChildren(grid, groupedLinks(category));
        });
        select(0);
      }
      opened = true;
      position();
      panel.hidden = false;
      header?.classList.add('omb-header-open');
      trigger.setAttribute('aria-controls', id);
      trigger.setAttribute('aria-expanded', 'true');
      loadAcademy();
    }
    function close() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      opened = false;
      panel.hidden = true;
      if (!document.querySelector('.omb-panel:not([hidden])')) header?.classList.remove('omb-header-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (originalControls) trigger.setAttribute('aria-controls', originalControls);
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 450);
    }
    document.addEventListener('orrling:menu-open', event => { if (event.detail !== panel && opened) close(); });
    new MutationObserver(() => {
      if (opened && trigger.getAttribute('aria-expanded') !== 'true') trigger.setAttribute('aria-expanded', 'true');
    }).observe(trigger, {attributes:true, attributeFilter:['aria-expanded']});
    let openTimer;
    trigger.addEventListener('pointerenter', () => { openTimer = setTimeout(open,300); });
    trigger.addEventListener('pointerleave', () => clearTimeout(openTimer));
    root.addEventListener('pointerleave', scheduleClose);
    panel.addEventListener('pointerenter', () => clearTimeout(closeTimer));
    panel.addEventListener('pointerleave', scheduleClose);
    trigger.addEventListener('click', event => {
      if (!desktop.matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      open();
    }, true);
    trigger.addEventListener('keydown', event => {
      if (!desktop.matches) return;
      if (['Enter',' ','ArrowDown'].includes(event.key)) {
        event.preventDefault(); event.stopImmediatePropagation(); open(); buttons[active].focus();
      } else if (event.key === 'Tab' && !event.shiftKey && opened) {
        event.preventDefault(); buttons[active].focus();
      }
    }, true);
    panel.addEventListener('click', event => { if (event.target.closest('a[href]')) close(); });
    panel.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll('a[href],button')).filter(el => el.tabIndex >= 0 && el.getClientRects().length);
      if (event.shiftKey && event.target === focusable[0]) { event.preventDefault(); trigger.focus(); }
      if (!event.shiftKey && event.target === focusable.at(-1)) {
        const next = root.nextElementSibling?.querySelector('a,button');
        if (next) { event.preventDefault(); close(); next.focus(); }
      }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && opened) { event.preventDefault(); close(); trigger.focus(); }
    });
    document.addEventListener('pointerdown', event => {
      if (opened && !panel.contains(event.target) && !root.contains(event.target)) close();
    });
    document.addEventListener('focusin', event => {
      if (opened && !panel.contains(event.target) && !root.contains(event.target)) close();
    });
    const navigation = root.parentElement;
    navigation.addEventListener('pointerover', event => {
      const item = event.target.closest('.gm-level-0');
      if (item && item !== root) scheduleClose();
    });
    desktop.addEventListener('change', close);
    window.addEventListener('resize', () => { if (opened) position(); }, {passive:true});
    window.addEventListener('scroll', close, {passive:true});
    select(0);
  }
  const scan = () => {
    managed.filter(item => !item.trigger.isConnected).forEach(item => item.panel.remove());
    document.querySelectorAll('.gm-level-0 > a.gm-target').forEach(link => {
    if (link.textContent.trim().toUpperCase() === 'BRIDAL & EVER ATELIER') enhance(link);
  });
  };
  scan();
  const observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('.gm-menu,.gm-level-0') || node.querySelector?.('.gm-menu'))))) scan();
  });
  observer.observe(document.body, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', scan);
})();

(() => {
  const desktop = matchMedia('(min-width:990px) and (hover:hover)');
  const configurations = {
    'CUSTOM DESIGN': {
      kind:'custom',
      cards:[
        ['/pages/custom-design','orrling-custom-design-the-process-watercolour.png?v=1792234512','contain'],
        ['/pages/custom-design-quote','orrling-atelier-quote.png?v=1792402833','contain']
      ]
    },
    'STUDIO': {
      kind:'studio',
      cards:[
        ['/pages/studio','orrling-atelier-studio.png?v=1792402856','cover'],
        ['/pages/timeline','Skarmavbild_2026-03-11_kl._07.26.45.png?v=1773210416','cover'],
        ['/pages/press','orrling-press-kmkTb35.png?v=1791194860','contain']
      ]
    },
    'ICON BRACELET': {
      kind:'icon',
      cards:[
        ['/products/create-your-bracelet-1','Skarmavbild2026-03-12kl.09.29.08.png?v=1773304204','cover'],
        ['/products/clasp','471_Bracelet__002_1.png?v=1771504912','contain'],
        ['/collections/icons','475_Pendant_GISELAICON_PicsP0_4.png?v=1772516621','contain'],
        ['/collections/icon-axis','485_BraceletPics__Pink__Stud0.png?v=1772431367','contain'],
        ['/collections/ad-on-icons','ICONCha__Brown_09.png?v=1773901592','contain']
      ]
    }
  };
  const enhanced = new WeakSet();
  const instances = [];
  let sequence = 0;
  const make = (tag, className) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    return element;
  };
  function enhance(trigger, config) {
    if (enhanced.has(trigger)) return;
    const root = trigger.parentElement;
    const source = root.querySelector(':scope > .gm-submenu');
    if (!source) return;
    const sourceLinks = Array.from(source.querySelectorAll('a[href]')).filter(a => a.textContent.trim() && a.getAttribute('href'));
    const cards = config.cards.map(([path,image,fit]) => ({link:sourceLinks.find(a => new URL(a.href).pathname === path),image,fit}));
    if (cards.some(card => !card.link)) return;
    enhanced.add(trigger);
    const panel = make('nav','omb-panel omb-direct omb-direct-' + config.kind);
    panel.id = 'orrling-direct-menu-' + (++sequence);
    panel.hidden = true;
    panel.setAttribute('aria-label',trigger.textContent.trim());
    const body = make('div','omb-body');
    const grid = make('div','omb-grid');
    const footer = make('div','omb-footer');
    const cloneLink = original => {
      const a = make('a');
      ['href','target','rel','translate'].forEach(name => {
        if (original.hasAttribute(name)) a.setAttribute(name,original.getAttribute(name));
      });
      if (original.classList.contains('notranslate')) a.classList.add('notranslate');
      return a;
    };
    const storyTemplates = ["<orrling-story class=\"orrling-story orrling-story--teal\" data-offset=\"0\" data-pause=\"Pause slideshow\" data-play=\"Play slideshow\" role=\"region\" aria-label=\"Icon Bracelet Creator\"><div class=\"orrling-story__frame\"><a class=\"orrling-story__link\" href=\"https://orrlingjewellery.com/products/create-your-bracelet-1\" aria-label=\"Icon Bracelet Creator\">\n<div class=\"orrling-story__slide is-active\" aria-hidden=\"false\"><img data-menu-src=\"https://orrlingjewellery.com/cdn/shop/files/Skarmavbild2026-03-11kl.22.06.50.png?width=1000\" alt=\"Gemstone charms on a brown Icon bracelet\" width=\"832\" height=\"832\" loading=\"lazy\" decoding=\"async\"></div>\n<div class=\"orrling-story__slide \" aria-hidden=\"true\"><img data-menu-src=\"https://orrlingjewellery.com/cdn/shop/files/Skarmavbild2026-03-11kl.21.49.22.png?width=1000\" alt=\"Turquoise bracelet with gold charms and open clasp\" width=\"832\" height=\"832\" loading=\"lazy\" decoding=\"async\"></div>\n<div class=\"orrling-story__slide \" aria-hidden=\"true\"><img data-menu-src=\"https://orrlingjewellery.com/cdn/shop/files/Skarmavbild2026-03-12kl.05.37.47.png?width=1000\" alt=\"Brown bracelet with gold charms and padlock\" width=\"832\" height=\"832\" loading=\"lazy\" decoding=\"async\"></div>\n</a><div class=\"orrling-story__controls\"><button class=\"orrling-story__dot\" type=\"button\" aria-label=\"Show image 1\" aria-current=\"true\"></button><button class=\"orrling-story__dot\" type=\"button\" aria-label=\"Show image 2\" aria-current=\"false\"></button><button class=\"orrling-story__dot\" type=\"button\" aria-label=\"Show image 3\" aria-current=\"false\"></button><button class=\"orrling-story__pause\" type=\"button\" aria-label=\"Pause slideshow\" aria-pressed=\"false\">\u2161</button></div></div></orrling-story>", "<orrling-story class=\"orrling-story orrling-story--tobacco\" data-offset=\"900\" data-pause=\"Pause slideshow\" data-play=\"Play slideshow\" role=\"region\" aria-label=\"Icon Universe\"><div class=\"orrling-story__frame\"><a class=\"orrling-story__link\" href=\"https://orrlingjewellery.com/collections/icons\" aria-label=\"Icon Universe\">\n<div class=\"orrling-story__slide is-active\" aria-hidden=\"false\"><img data-menu-src=\"https://orrlingjewellery.com/cdn/shop/files/Skarmavbild2026-03-11kl.21.52.24.png?width=1000\" alt=\"Gold crocodile and love charms on a turquoise bracelet\" width=\"832\" height=\"832\" loading=\"lazy\" decoding=\"async\"></div>\n<div class=\"orrling-story__slide \" aria-hidden=\"true\"><img data-menu-src=\"https://orrlingjewellery.com/cdn/shop/files/Skarmavbild2026-03-12kl.21.51.31.png?width=1000\" alt=\"Gisela flower charms on coloured bracelets\" width=\"832\" height=\"832\" loading=\"lazy\" decoding=\"async\"></div>\n<div class=\"orrling-story__slide \" aria-hidden=\"true\"><img data-menu-src=\"https://orrlingjewellery.com/cdn/shop/files/Skarmavbild2026-03-11kl.22.06.50.png?width=1000\" alt=\"Tiger eye, malachite and gemstone Icon charms\" width=\"832\" height=\"832\" loading=\"lazy\" decoding=\"async\"></div>\n</a><div class=\"orrling-story__controls\"><button class=\"orrling-story__dot\" type=\"button\" aria-label=\"Show image 1\" aria-current=\"true\"></button><button class=\"orrling-story__dot\" type=\"button\" aria-label=\"Show image 2\" aria-current=\"false\"></button><button class=\"orrling-story__dot\" type=\"button\" aria-label=\"Show image 3\" aria-current=\"false\"></button><button class=\"orrling-story__pause\" type=\"button\" aria-label=\"Pause slideshow\" aria-pressed=\"false\">\u2161</button></div></div></orrling-story>"];
    cards.forEach(({link,image,fit}) => {
      const storyIndex = config.kind === 'icon' ? ['/products/create-your-bracelet-1','/collections/icons'].indexOf(new URL(link.href).pathname) : -1;
      if (storyIndex !== -1) {
        const wrapper = make('div','omb-card omb-story-card');
        const template = document.createElement('template');
        template.innerHTML = storyTemplates[storyIndex];
        const story = template.content.firstElementChild;
        story.querySelector('a').href = link.href;
        story.setAttribute('aria-label',link.textContent.trim());
        const label = cloneLink(link);
        label.textContent = link.textContent.trim();
        wrapper.append(story,label);
        grid.append(wrapper);
        return;
      }
      const a = cloneLink(link);
      a.classList.add('omb-card');
      const img = make('img');
      img.dataset.menuSrc = 'https://cdn.shopify.com/s/files/1/0953/4645/9011/files/' + image + '&width=800';
      img.width = 400;
      img.height = 400;
      img.alt = '';
      img.decoding = 'async';
      img.style.objectFit = fit;
      if (config.kind === 'studio') {
        const path = new URL(link.href).pathname;
        img.style.filter = path === '/pages/studio' ? 'saturate(.78) contrast(.96) brightness(1.03)' : path === '/pages/timeline' ? 'sepia(.16) saturate(.65) contrast(.96)' : 'saturate(.82) sepia(.06) contrast(.96) brightness(1.06)';
        img.style.backgroundColor = '#f7f5f0';
      }
      const label = make('span');
      label.textContent = link.textContent.trim();
      if (config.kind === 'icon') {
        const media = make('div','omb-icon-media');
        media.append(img);
        a.append(media,label);
      } else a.append(img,label);
      grid.append(a);
    });
    sourceLinks.filter(link => !cards.some(card => card.link === link)).forEach(link => {
      const a = cloneLink(link);
      a.textContent = link.textContent.trim();
      footer.append(a);
    });
    body.append(grid);
    panel.append(body,footer);
    document.body.append(panel);
    root.classList.add('omb-source');
    const header = trigger.closest('header-component');
    const controls = trigger.getAttribute('aria-controls');
    let opened = false, timer;
    const controller = new AbortController();
    const listen = (el,event,fn,options={}) => el.addEventListener(event,fn,{...options,signal:controller.signal});
    function close() {
      clearTimeout(openTimer);
      clearTimeout(timer);
      opened = false;
      panel.hidden = true;
      if (!document.querySelector('.omb-panel:not([hidden])')) header?.classList.remove('omb-header-open');
      trigger.setAttribute('aria-expanded','false');
      if (controls) trigger.setAttribute('aria-controls',controls);
      else trigger.removeAttribute('aria-controls');
    }
    function position() {
      const rect = header?.getBoundingClientRect() || trigger.getBoundingClientRect();
      panel.style.setProperty('--omb-top',Math.max(0,rect.bottom) + 'px');
    }
    function open() {
      clearTimeout(openTimer);
      if (!desktop.matches || !trigger.getClientRects().length) return;
      clearTimeout(timer);
      document.dispatchEvent(new CustomEvent('orrling:menu-open',{detail:panel}));
      panel.querySelectorAll('img[data-menu-src]').forEach(img => {
        img.src = img.dataset.menuSrc;
        delete img.dataset.menuSrc;
      });
      position();
      opened = true;
      panel.hidden = false;
      header?.classList.add('omb-header-open');
      trigger.setAttribute('aria-controls',panel.id);
      trigger.setAttribute('aria-expanded','true');
    }
    const scheduleClose = () => { clearTimeout(timer); timer = setTimeout(close,450); };
    const expandedObserver = new MutationObserver(() => {
      if (opened && trigger.getAttribute('aria-expanded') !== 'true') trigger.setAttribute('aria-expanded','true');
    });
    expandedObserver.observe(trigger,{attributes:true,attributeFilter:['aria-expanded']});
    let openTimer;
    listen(trigger,'pointerenter',() => { openTimer = setTimeout(open,300); });
    listen(trigger,'pointerleave',() => clearTimeout(openTimer));
    listen(root,'pointerleave',scheduleClose);
    listen(panel,'pointerenter',() => clearTimeout(timer));
    listen(panel,'pointerleave',scheduleClose);
    listen(trigger,'click',event => {
      if (!desktop.matches) return;
      event.preventDefault(); event.stopImmediatePropagation(); open();
    },{capture:true});
    listen(trigger,'keydown',event => {
      if (!desktop.matches) return;
      if (['Enter',' ','ArrowDown'].includes(event.key) || (event.key === 'Tab' && !event.shiftKey && opened)) {
        event.preventDefault(); event.stopImmediatePropagation(); open(); grid.querySelector('a').focus({preventScroll:true});
      }
    },{capture:true});
    listen(panel,'keydown',event => {
      if (event.key !== 'Tab') return;
      const links = Array.from(panel.querySelectorAll('a[href],button')).filter(el => el.getClientRects().length);
      if (event.shiftKey && event.target === links[0]) { event.preventDefault(); trigger.focus({preventScroll:true}); }
      if (!event.shiftKey && event.target === links.at(-1)) {
        const next = root.nextElementSibling?.querySelector('a,button');
        if (next) { event.preventDefault(); close(); next.focus({preventScroll:true}); }
      }
    });
    listen(document,'keydown',event => {
      if (opened && event.key === 'Escape') { event.preventDefault(); close(); trigger.focus({preventScroll:true}); }
    });
    ['pointerdown','focusin'].forEach(type => listen(document,type,event => {
      if (opened && !root.contains(event.target) && !panel.contains(event.target)) close();
    }));
    listen(document,'orrling:menu-open',event => { if (opened && event.detail !== panel) close(); });
    listen(root.parentElement,'pointerover',event => {
      const item = event.target.closest('.gm-level-0');
      if (opened && item && item !== root) scheduleClose();
    });
    listen(window,'resize',() => { if (opened) position(); },{passive:true});
    listen(window,'scroll',() => { if (opened) close(); },{passive:true});
    listen(desktop,'change',close);
    instances.push({trigger,dispose:() => {close();controller.abort();expandedObserver.disconnect();panel.remove();}});
  }
  function scan() {
    for (let i=instances.length-1;i>=0;i--) {
      if (!instances[i].trigger.isConnected) { instances[i].dispose(); instances.splice(i,1); }
    }
    document.querySelectorAll('header-menu .gm-level-0 > a.gm-target').forEach(trigger => {
      const config = configurations[trigger.textContent.trim().toUpperCase()];
      if (config) enhance(trigger,config);
    });
  }
  scan();
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('.gm-menu,.gm-level-0') || node.querySelector?.('.gm-menu'))))) scan();
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',scan);
})();

